import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { isNumeric, isNumber } from './assertion.esm.js';
import { toNumber } from './number.esm.js';
import { memoizedGet } from './object.esm.js';
import { SizeEnum } from '../themes/size-enum.esm.js';

var SizeIndex = Object.keys(SizeEnum);
var isSizeIndex = function isSizeIndex(v) {
  return SizeIndex.includes("".concat(v));
};
function pxToRem(value) {
  var basePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return typeof value === 'number' ? "".concat(value / basePx, "rem") : value.includes('px') ? "".concat(Number(value.replace('px', '')) / basePx, "rem") : value;
}
function remToPx(value) {
  var basePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  return typeof value === 'number' ? "".concat(value, "px") : value.includes('rem') ? "".concat(Number(value.replace('rem', '')) * basePx, "px") : value;
}
var resolveSizeValue = function resolveSizeValue(theme) {
  return function (n, sizesKey) {
    var isNegative = typeof n === 'string' && n.startsWith('-') || isNumber(n) && Number(n) < 0;
    var t = isNegative ? isNumber(n) ? Math.abs(n) : "".concat(n).slice(1) : n;
    var v = typeof t === 'string' && t.startsWith('sizes') ? memoizedGet(theme, t, t) : memoizedGet(memoizedGet(theme, sizesKey), t, t);
    if (!isNumber(v)) {
      return isNegative ? '-' + v : v;
    }
    return Number(v) * (isNegative ? -1 : 1);
  };
};
var resolveSize = function resolveSize(size, sizes) {
  var getSize = function getSize(v) {
    return v && isSizeIndex(v) && sizes ? sizes[v] : v;
  };
  return Array.isArray(size) ? size.map(getSize) : getSize(size);
};
var themeFontIndexToFontSize = function themeFontIndexToFontSize(theme, indices) {
  return Array.isArray(indices) ? indices.map(function (i) {
    return resolveSizeValue(theme)(i, 'fontSizes');
  }) : resolveSizeValue(theme)(indices, 'fontSizes');
};
var getNextSize = function getNextSize(fromSize) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (fromSize === null) return null;
  if (fromSize && !isSizeIndex(fromSize)) {
    if (typeof fromSize === 'number') {
      var retVal = fromSize + step * 1.5;
      return retVal < 6 ? fromSize : retVal;
    }
    return fromSize;
  }
  var currentIndex = fromSize ? SizeIndex.indexOf(fromSize) : -1;
  var nextIndex = currentIndex + step;
  if (nextIndex >= 0 && nextIndex <= SizeIndex.length - 1) {
    return SizeIndex[nextIndex];
  } else if (nextIndex < 0) {
    return SizeIndex[0];
  } else if (nextIndex > SizeIndex.length - 1) {
    return SizeIndex[SizeIndex.length - 1];
  }
  return SizeIndex[currentIndex];
};
var getStepSize = function getStepSize(size) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  return Array.isArray(size) ? size.map(function (i) {
    return getNextSize(i, step);
  }) : getNextSize(size, step);
};
var resolveIconFromFontSize = function resolveIconFromFontSize(size) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return resolveSize(Array.isArray(size) ? size.map(function (i) {
    return getNextSize(i, step);
  }) : getNextSize(size, step), memoizedGet(theme, 'sizes.icon'));
};
function toBaseUnit(subject) {
  var targetUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  var sourceUnit = targetUnit === 'px' ? 'rem' : 'px';
  function convert(value) {
    if (typeof value === 'string' && value.includes(sourceUnit)) {
      var numberValue = toNumber(value);
      return isNumber(numberValue) ? "".concat(targetUnit === 'rem' ? numberValue / 16 : numberValue * 16).concat(targetUnit) : value;
    }
    return value;
  }
  return Object.keys(subject).reduce(function (acc, cur) {
    var curField = subject[cur];
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur, Array.isArray(curField) ? curField.map(function (v) {
      return convert(v);
    }) : convert(curField)));
  }, {});
}
function isValidUnit(value) {
  return isNumeric(value) && typeof value === 'string' && (value.endsWith('rem') || value.endsWith('em') || value.endsWith('px'));
}

export { getNextSize, getStepSize, isSizeIndex, isValidUnit, pxToRem, remToPx, resolveIconFromFontSize, resolveSize, resolveSizeValue, themeFontIndexToFontSize, toBaseUnit };
//# sourceMappingURL=size-utils.esm.js.map
